export default {"src":"/_next/static/media/cobbler.b2c334e1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};